import getConfig from 'next/config';

import { REST_VIDEOS } from '../constants';

const { publicRuntimeConfig } = getConfig();

const FPS_TITLE = '5PS';

const REST_SUFFIXES = Object.fromEntries(REST_VIDEOS.map(({ id }) => [id, 'Rest']));

export const getMuxEnvKey = () => publicRuntimeConfig.muxEnvKey;

/**
 * A workout swaps the player's source dozens of times — tutorial, demo and rest
 * are three separate assets, each a cold start. Suffixing the title keeps them
 * apart in Mux Data so startup time can be read per transition rather than
 * averaged into one number per exercise.
 */
const getVideoTitle = (context, video) => {
  const { program, session, exercise, fps } = context;

  if (program) {
    return fps ? `Program Introduction: ${FPS_TITLE}` : 'Program Introduction';
  }

  if (session && exercise) {
    const suffixes = {
      ...REST_SUFFIXES,
      // An exercise may carry only one of the two — #188. Spreading keeps a
      // missing video out of the map instead of throwing on `.id`.
      ...(exercise.fullVideo ? { [exercise.fullVideo.id]: 'Tutorial' } : {}),
      ...(exercise.video ? { [exercise.video.id]: 'Demo' } : {}),
    };
    const suffix = video ? suffixes[video.id] : undefined;

    return suffix ? `${exercise.name} (${suffix})` : exercise.name;
  }

  if (session) {
    return 'Session Introduction';
  }

  return fps ? FPS_TITLE : 'Praxis Video';
};

const getVideoSeries = (context) => {
  const program = context.session?.program || context.program;

  return program ? program.name : 'Praxis Video Series';
};

/**
 * Per-view metadata for mux-player, which reports to Mux Data itself once it
 * has an env key. `video_duration` is deliberately omitted: mux-player reads it
 * off the media element, and our stored duration is in seconds where Mux Data
 * expects milliseconds.
 */
export const getVideoMetadata = (context, video) => ({
  video_id: video?.id,
  video_title: getVideoTitle(context, video),
  video_series: getVideoSeries(context),
  viewer_user_id: context.user?.id,
});
